import React, { useEffect, useState } from "react";
import api from "../../utils/axios";
import { AgGridReact } from "ag-grid-react";
import { Button, Divider, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import DefaultInput from "../../components/form/DefaultInput";
import { toast } from "react-toastify";
import useLang from "../../hooks/useLang";
type UserRole = {
	id: number;
	description?: string;
};
const UserRoleManagement = () => {
	const defaultColDef = {
		sortable: true,
		filter: true,
		wrapHeaderText: true,
		resizable: true,
		filterParams: { excelMode: "windows" },
		autoSizeAllColumns: true,
	};
	const { strings } = useLang("userRoleManagement");

	const tableColumns = [
		{
			field: "id",
			headerName: strings?.id,
			type: "numericColumn",
			filter: "agNumberColumnFilter",
		},
		{
			field: "description",
			headerName: strings?.description,
			editable: true,
		},
	];
	const [openAddUserRoleModal, setOpenAddUserRoleModal] =
		useState<boolean>(false);
	const createUserRole = async (description: string) => {
		try {
			const response = await api.post("UserRole", {
				id: -1,
				description,
			});
			if (response.status === 200) {
				console.log("User role created with ID:", response.data);
				fetchUserRoles();
				setOpenAddUserRoleModal(false);
				setDescription("");
			}
		} catch (error) {
			console.error("Error creating user role:", error);
		}

		return null;
	};

	const updateUserRole = async (id: number, description: string) => {
		try {
			const response = await api.post("UserRole/Update", {
				id,
				description,
			});
			if (response.status === 204) {
				console.log("User role updated");
				fetchUserRoles();
			}
		} catch (error) {
			console.error("Error updating user role:", error);
		}
	};

	const fetchUserRoles = async () => {
		try {
			const response = await api.get<UserRole[]>("UserRole");
			if (response.status === 200) {
				setUserRoles(response.data);
			}
		} catch (error) {
			console.error("Error fetching user roles:", error);
		}

		return [];
	};

	const [userRoles, setUserRoles] = useState<UserRole[]>([]);
	const [description, setDescription] = useState<string>("");

	useEffect(() => {
		(async () => {
			await fetchUserRoles();
		})();
	}, []);

	const onRowEdit = async (row: any) => {
		await updateUserRole(row.data.id, row.data.description);
		await fetchUserRoles();
	};

	const handleAddUserRole = async () => {
		if (description.length <= 0) {
			toast.error(strings?.descriptionEmpty);
			return;
		}
		await createUserRole(description);
		await fetchUserRoles();
	};

	return (
		<>
			<div>
				<Modal
					open={openAddUserRoleModal}
					title={strings?.addUserRole}
					onCancel={() => setOpenAddUserRoleModal(false)}
					onOk={handleAddUserRole}
					okButtonProps={{ className: "bg-blue-500" }}
				>
					<Divider />
					<div className="flex flex-col items-center">
						<DefaultInput
							placeholder="Role"
							value={description}
							label={strings?.userRole}
							onChange={(e) => setDescription(e.target.value)}
						/>
					</div>
				</Modal>
				<div className="ag-theme-alpine" style={{ height: 600 }}>
					<Button
						className="border-[#4F16C233] text-[#4F16C2] flex items-center"
						onClick={() => setOpenAddUserRoleModal(true)}
					>
						<PlusOutlined />
						{strings?.add}
					</Button>
					<AgGridReact
						rowData={userRoles}
						defaultColDef={defaultColDef}
						columnDefs={tableColumns}
						enterMovesDown={true}
						enterMovesDownAfterEdit={true}
						undoRedoCellEditing={true}
						undoRedoCellEditingLimit={20}
						suppressCopyRowsToClipboard={true}
						rowSelection="single"
						enableRangeSelection={true}
						editType={"fullRow"}
						onRowValueChanged={(event) => {
							onRowEdit(event);
						}}
					/>
				</div>
			</div>
		</>
	);
};

export default UserRoleManagement;
